import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-line-avg-events-per-session',
  templateUrl: './line-avg-events-per-session.component.html',
  styleUrl: './line-avg-events-per-session.component.scss',
})
export class LineAvgEventsPerSessionComponent {
  isLoading = true;

  options: echarts.EChartsOption = {
    legend: {
      show: false,
    },
    grid: { left: 40, right: 35, top: 40, bottom: 40 },
  };

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.lineAvgEventsPerSession$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('lineAvgEventsPerSession');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getLineAvgEventsPerSession().subscribe();
  }

  get series() {
    return this.analyticsService.lineAvgEventsPerSession$.value?.series;
  }

  get labels() {
    return this.analyticsService.lineAvgEventsPerSession$.value?.labels;
  }
}
